import React, { useState, useEffect, useContext } from "react"
import FirebaseContext from "components/Common/FirebaseContext"
import { css } from "@emotion/core"
import DateLabel from "components/UI/DateLabel"
import t from "theme"
import BeatLoader from "react-spinners/BeatLoader"

const ExternalLink = ({ url, type = "large", ...props }) => {
    const firebase = useContext(FirebaseContext)
    const [metadata, setMetadata] = useState(null)
    var fbFunction = firebase.functions().httpsCallable("DRgetMetadata")

    useEffect(() => {
        async function getMetadata() {
            const linkMetadata = await fbFunction({ url: url })
            setMetadata(linkMetadata)
            console.log(linkMetadata)
        }
        getMetadata()
    }, [])

    return metadata ? (
        <a href={url} {...props}>
            {metadata.data.title &&
                (type === "large" ? (
                    <h3>{metadata.data.title}</h3>
                ) : (
                    <div
                        css={css`
                            font-size: ${t.font.size[4]};
                        `}>
                        {metadata.data.title}
                    </div>
                ))}
            {metadata.data.description && (
                <div
                    css={css`
                        margin-top: ${t.space[4]};
                        color: ${t.color.lighttext};
                    `}>
                    {metadata.data.description}
                </div>
            )}
            {metadata.data.date && <DateLabel date={metadata.data.date} />}
        </a>
    ) : (
        <BeatLoader size={15} color={t.color.subtlegrey} />
    )
}

export default ExternalLink
